import React, { useCallback, useState, useEffect } from 'react'
import { hooks } from '@front/volcanion'
import Callbacks from './callbacks'

import { TimeUtils } from '@front/volcanion/utils'

const withContainer = Component => ({ disabled }) => {
  const isMounted = hooks.useFormStatus('isMounted')
  const [eta, setEta] = useState(null)
  const [estimatedDelay, setEstimatedDelay] = useState(null)
  const [{ selected_user, user_id, record_id, margin: traffic_margin }] = hooks.useFormState()
  const owner = selected_user || user_id
  const [
    driver_opts,
    vehicle_opts,
    source_details,
    source_formatted_address,
    commercial_package,
    schedule_type,
    requestedAt,
    special_price,
    estimation_type,
    load_count,
    has_luggage,
    companycontract_id,
    commercial_formula_id,
  ] = hooks.useFieldValues([
    'driver_opts',
    'vehicle_opts',
    'source',
    'source.formatted_address',
    'commercial_package',
    'schedule_type',
    'requestedAt',
    'special_price',
    'estimation_type',
    'load_count',
    'has_luggage',
    'user.companycontract',
    'user.commercial_formula',
  ])

  const { DURATION_DRIVER_TOO_EARLY } = hooks.useRelayConstants(['DURATION_DRIVER_TOO_EARLY'])
  const [availableEstimation] = hooks.useSelectedEstimation(commercial_package)
  const [selectedEstimation] = hooks.useSelectedEstimation(commercial_package, estimation_type)
  const [selectedDriverEstimation] = hooks.useSelectedEstimation(commercial_package, estimation_type, 'driver_estimations')

  const [order] = hooks.useModel('order', [record_id], { populate: ['quotation', 'info', 'driver_estimation', 'current_target.eta', 'assigned_transport'], single: true })
  const [companycontract] = hooks.useModel('companycontract', [companycontract_id], { single: true })
  const [commercial_formula] = hooks.useModel('commercialformula', [commercial_formula_id], { single: true })
  hooks.useOrderETA(record_id)

  const getCustomProps = useCallback(Callbacks.getCustomPropsHandler(selectedEstimation, selectedDriverEstimation, order, requestedAt, schedule_type, eta, traffic_margin),
    [selectedEstimation, selectedDriverEstimation, order, requestedAt, schedule_type, eta, traffic_margin])
  const [getDetails] = hooks.useModelFunction('address', 'getDetails')
  const refreshETA = useCallback(Callbacks.refreshETAHandler(getDetails, setEta, setEstimatedDelay), [getDetails, setEta, setEstimatedDelay])

  useEffect(() => {
    if (!isMounted || !commercial_package || schedule_type !== 'immediate') return
    refreshETA(driver_opts, vehicle_opts, source_details, owner, commercial_package, load_count, has_luggage)
  }, [commercial_package, source_formatted_address, owner, load_count, has_luggage])

  const margin = TimeUtils.secondsToTime((traffic_margin || _.get(order, 'info.margin')) * 60, null, { hide_seconds: true })

  const delayAtSource = companycontract?.delay_at_source ?? commercial_formula?.delay_at_source ?? DURATION_DRIVER_TOO_EARLY

  const mergedProps = {
    schedule_type,
    margin,
    disabled,
    estimation_type,
    isManualPriceRequired: estimation_type === 'special' && availableEstimation?.type !== 'special',
    special_price,
    eta,
    estimatedDelay,
    delayAtSource,
    ...getCustomProps()
  }

  return (
    <Component {...mergedProps} />
  )
}
export default withContainer
